import { Component } from '@angular/core';

@Component({
    selector: 'investigations',
    template: '<router-outlet></router-outlet>',
    standalone: false,
})
export class InvestigationsComponent {}
